import React from 'react';
import { Typography } from "@material-ui/core";
import NumberFormat from "react-number-format";

const ChangePercentIndicator = ({value, prevValue}) => {
  const trendColor = (v, prevV) => {
    if (v > prevV) return '#0E7C0E';
    if (v < prevV) return '#E40909';
    return 'inherit';
  }
  const divStyle = {
    display: 'inline-block', fontSize: '11px', marginLeft: '10px',
    verticalAlign: 'text-top', color: trendColor(value, prevValue)
  };
  const percentage = Math.round(Math.abs(value - prevValue) / prevValue * 1000) / 10;
  return (<div style={divStyle}>
    {value > prevValue && <span>▲ </span>}
    {value < prevValue && <span>▼ </span>}
    <span>
      {percentage === Infinity ? '∞' : `${percentage}%`}
    </span>
  </div>);
}

const SummaryReportNumberView = ({ title, value, prevValue, isUsd }) => (
  <div>
    <Typography style={{fontSize: 14}}>{title}</Typography>
    <div style={{marginTop: 8, marginBottom: 5}}>
      <span style={{fontSize: '22px', fontWeight: 'bolder'}}>
        {!isUsd && <>{value}</>}
        {isUsd && <NumberFormat value={value} displayType="text" thousandSeparator prefix="$" />}
      </span>
      {(prevValue || prevValue === 0) && value !== prevValue && <ChangePercentIndicator value={value} prevValue={prevValue} /> }
    </div>

    {(prevValue || prevValue === 0) && value !== prevValue && (
      <Typography style={{fontSize: 12}}>
        {value > prevValue && '+ '}
        {value < prevValue && '- '}
        {!isUsd && <span>{Math.abs(value - prevValue)}</span>}
        {isUsd && <NumberFormat value={Math.abs(value - prevValue)} displayType="text" thousandSeparator prefix="$" />}
        {' this week'}
      </Typography>
    )}

    {(prevValue || prevValue === 0) && value === prevValue &&
      <Typography style={{fontSize: 12}}>No change this week</Typography>
    }

  </div>
)

export default SummaryReportNumberView;
